/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_A7Inputs */

const en_pc_faq_a7 = /** @type {(inputs: Pc_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows on x64, ARM64 and 32-bit PCs, macOS on Apple silicon and Intel, Linux on x86_64, ARM64 and RISC-V, and FreeBSD. Anything with a modern browser, including a Chromebook, can use PdfCraft Online.`)
};

const zh_pc_faq_a7 = /** @type {(inputs: Pc_Faq_A7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows（x64、ARM64、32 位）、macOS（Apple 芯片与 Intel）、Linux（x86_64、ARM64、RISC-V）以及 FreeBSD。任何装有现代浏览器的设备，包括 Chromebook，都可以使用 PdfCraft 在线版。`)
};

/**
* | output |
* | --- |
* | "Windows on x64, ARM64 and 32-bit PCs, macOS on Apple silicon and Intel, Linux on x86_64, ARM64 and RISC-V, and FreeBSD. Anything with a modern browser, inclu..." |
*
* @param {Pc_Faq_A7Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_a7 = /** @type {((inputs?: Pc_Faq_A7Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_A7Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_a7(inputs)
	return zh_pc_faq_a7(inputs)
});
export { pc_faq_a7 as "pc.faq.a7" }